
import React, {Component} from 'react'
import GenericDockButton from './GenericDockButton'
import TillStatusButton from './tillStatus/TillStatusButton'
import NotificationButton from './NotificationButton'

const translator = require('../../../utils/translator/translator.js');
const navigationButtonsIds = require('../navigationButtonsIds');

class DockButtonFacade extends Component 
{
    render()
    {
        if (this.props.button == navigationButtonsIds.openCloseTillButton)
            return <TillStatusButton    button={this.props.button} 
                                        onClick={this.props.onClick} 
                                        marginLeft={this.props.marginLeft}
                                        marginRight={this.props.marginRight}
                                        isPageView={false}/>

        if (this.props.button == navigationButtonsIds.notifications)
            return <NotificationButton  button={this.props.button} 
                                        onClick={this.props.onClick} 
                                        marginLeft={this.props.marginLeft}
                                        marginRight={this.props.marginRight}
                                        isPageView={false}/>

        return <GenericDockButton   button={this.props.button} 
                                    onClick={this.props.onClick} 
                                    marginLeft={this.props.marginLeft}
                                    marginRight={this.props.marginRight}
                                    caption={translator.getLabel(this.props.button)}/>
    }
}

export default DockButtonFacade